import type { BannerItem } from '../services/resortAdminApi';

export interface BannerFormData {
  resort: string;        // '' when none selected
  all_resorts: boolean;
  start_date: string;    // YYYY-MM-DD
  end_date: string;      // YYYY-MM-DD
  banners: BannerItem[];
}

export const MAX_BANNERS = 3;

/** Returns a list of human-readable validation errors ('' = valid). */
export function validateBannerForm(f: BannerFormData): string[] {
  const errors: string[] = [];

  if (!f.all_resorts && !f.resort) {
    errors.push('Select a resort or choose "All resorts"');
  }
  if (!f.start_date) errors.push('Start date is required');
  if (!f.end_date) errors.push('End date is required');
  // YYYY-MM-DD strings compare correctly lexicographically.
  if (f.start_date && f.end_date && f.start_date > f.end_date) {
    errors.push('Start date must be before end date');
  }
  if (f.banners.length === 0) {
    errors.push('Add at least one banner');
  }
  if (f.banners.length > MAX_BANNERS) {
    errors.push(`A campaign can have at most ${MAX_BANNERS} banners`);
  }
  f.banners.forEach((b, i) => {
    if (!b.image) errors.push(`Banner ${i + 1} needs an image`);
  });

  return errors;
}
